import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'modules/app-core/modal'
import uuidV1 from 'uuid/v1'

import { Button } from '@hixme-ui/forms'
import Container from '@hixme-ui/container'
import Title from '@hixme-ui/title'
import Text from '@hixme-ui/text'
import Table from '@hixme-ui/table'
import moment from 'moment'

import Message from './Message'
import classes from './MessageList.module.scss'

const MessageList = ({
  messageList,
  message,
  isListView,
  handleMessageClick,
  handleToggleView,
  isProcessingSearch,
  isProcessingMessage,
}) => {
  const messageClick = (messageId) => {
    handleMessageClick(messageId)
  }
  /* eslint-disable */
  return (
    <div>
      {isListView ? (
        <Container flex noPadding direction="column" alignItems="center">
          <Container flex noPadding margin="0 0 10px 0">
            <Title>Messages</Title>
          </Container>
          <Container flex noPadding height="60px">
            {isProcessingSearch && <Text primary>Getting All Messages...</Text>}
            {isProcessingMessage && <Text primary>Getting Message...</Text>}
          </Container>
          <Table striped>
            <thead>
              <tr>
                <th className={`${classes.centered}`}>From</th>
                <th className={`${classes.centered}`}>Subject</th>
                <th className={`${classes.centered}`}>Date Created</th>
              </tr>
            </thead>
            <tbody key={uuidV1()}>
              {messageList.map((msg) => (
                <tr
                  style={{ cursor: 'pointer' }}
                  key={uuidV1()}
                  onClick={function msgClick() {
                    messageClick(msg.Id)
                  }}
                >
                  <td>{msg.From}</td>
                  <td>{msg.Subject}</td>
                  <td>
                    {moment(msg.CreatedDt).format(
                      'dddd, MMMM Do YYYY, h:mm:ss a'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
      ) : (
        <div>
          <Button small outline onClick={handleToggleView}>
            Back to messages
          </Button>
          <Message {...message} />
        </div>
      )}
    </div>
  )
}

const MessageListModal = Modal.containers.Modal({
  content: {
    position: 'top',
    size: 'large',
    styles: {
      width: '100%',
      margin: '50px 0 0 0',
    },
  },
  overlay: {
    hideCloseButton: false,
    routeOnHide: false,
    dark: false,
  },
})(MessageList)

MessageList.displayName = 'MessageList'

MessageList.propTypes = {
  messageList: PropTypes.array,
  isListView: PropTypes.bool,
  message: PropTypes.object,
  handleMessageClick: PropTypes.func,
  handleToggleView: PropTypes.func,
  isProcessingSearch: PropTypes.bool,
  isProcessingMessage: PropTypes.bool,
}

MessageList.defaultProps = {
  messageList: [],
  isListView: false,
  message: {},
  handleMessageClick: null,
  handleToggleView: null,
  isProcessingSearch: false,
  isProcessingMessage: false,
}

export default MessageListModal
